module.exports = __webpack_public_path__ + "static/img/4.8e0ec81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/4.png
// module id = 89TQ
// module chunks = 0